export default function DSA_Minimum_Spanning_Tree() {
  return <div>DSA_Minimum_Spanning_Tree Component</div>;
}
